var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("c-button", {
          staticClass: "btn-close",
          attrs: { primary: "", size: "lg", icon: "cross" },
          on: {
            click: function($event) {
              return _vm.close()
            }
          }
        }),
        _vm._v(" "),
        _c("user-profile"),
        _vm._v(" "),
        _vm.$can("awards") ||
        _vm.$can("cashback_tab") ||
        _vm.$can("cashback_tab")
          ? _c("wallet-buttons", {
              staticClass: "buttons",
              on: {
                close: function($event) {
                  return _vm.close()
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        !!(_vm.config || {}).has_request_partners
          ? _c(
              "c-button",
              {
                staticClass: "become-partner",
                attrs: { size: "lg", icon: "certificate" },
                on: {
                  click: function($event) {
                    return _vm.redirectAndClose()
                  }
                }
              },
              [_vm._v("\n      Seja parceiro\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.menuItems, function(item) {
          return _c("layout-sidebar-item", {
            key: item.name,
            staticClass: "item",
            attrs: { arrow: "", item: item },
            nativeOn: {
              click: function($event) {
                return _vm.close()
              }
            }
          })
        }),
        _vm._v(" "),
        (_vm.config.has_api_access && _vm.config.logout) ||
        !_vm.config.has_api_access
          ? _c("layout-sidebar-item", {
              staticClass: "logout",
              attrs: { item: _vm.logout },
              nativeOn: {
                click: function($event) {
                  return _vm.logoutAction()
                }
              }
            })
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-000382c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000382c1","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Layout/LayoutSidebar.vue
// module id = 2135
// module chunks = 1610